import { render, staticRenderFns } from "./CMXmlDetails.vue?vue&type=template&id=d95fb86a&scoped=true&"
import script from "./CMXmlDetails.vue?vue&type=script&lang=js&"
export * from "./CMXmlDetails.vue?vue&type=script&lang=js&"
import style0 from "./CMXmlDetails.vue?vue&type=style&index=0&id=d95fb86a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d95fb86a",
  null
  
)

export default component.exports